import { render, staticRenderFns } from "./teacherFlexibleReview.vue?vue&type=template&id=5be91e63&scoped=true"
import script from "./teacherFlexibleReview.vue?vue&type=script&lang=js"
export * from "./teacherFlexibleReview.vue?vue&type=script&lang=js"
import style0 from "./teacherFlexibleReview.vue?vue&type=style&index=0&id=5be91e63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be91e63",
  null
  
)

export default component.exports